import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  LogoLoader,
  PermissionTable,
  showToast,
} from "../../../../../../../components";
import { mapTableRows } from "../../../../../../../utils";
import {
  getAllRoles,
  updateModuleAccess,
} from "../../../../../../../redux/slices/setting/settingApi";

const Benchsales = () => {
  const [checkedRows, setCheckedRows] = useState({});
  const [checkMultiSelected, setCheckMultiSelected] = useState();
  const [loading, setLoading] = useState(false);
  const [originalModuleAccess, setOriginalModuleAccess] = useState([]);
  const [roleId, setRoleId] = useState(null);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const handleCheckboxChange = (rowId, values) => {
    setCheckedRows((prev) => ({
      ...prev,
      [rowId]: values,
    }));
  };

  const handleRoleChange = async (role) => {
    setCheckMultiSelected(role.label);

    try {
      setLoading(true);
      const response = await getAllRoles({
        coll: "Role",
        fil: {
          name: { type: "NONE", value: role.label },
        },
        ret: "moduleAccess",
      });

      const moduleAccessArray =
        response?.data?.data?.[0]?.moduleAccess.benchsales || [];
      const id = response?.data?.data?.[0]?._id || null;
      console.log(moduleAccessArray, "moduleAccessArray");
      setRoleId(id);
      setOriginalModuleAccess(moduleAccessArray);
      const preselectedKeys = extractCheckedKeys(moduleAccessArray);
      // const newChecked = {};
      // rows.forEach((row) => {
      //   if (moduleAccessArray.includes(row.id)) {
      //     newChecked[row.id] = "1";
      //   }
      // });
      // setCheckedRows(newChecked);
      setSelectedPermissions(moduleAccessArray);
      setCheckedRows(preselectedKeys);
    } catch (error) {
      console.error("Failed to fetch role access:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!roleId) {
      showToast("Role not Selected", "error", 2000);
      return;
    }
    const payload = {
      $set: {
        "moduleAccess.benchsales": selectedPermissions,
      },
    };

    try {
      setLoading(true);
      // console.log("Payload to be sent:", payload);
      const res = await updateModuleAccess({ id: roleId, payload });
      if (res?.data) {
        const refreshed = await getAllRoles({
          coll: "Role",
          fil: { _id: { type: "NONE", value: roleId } },
          ret: "moduleAccess",
        });

        const updatedAccess =
          refreshed?.data?.data?.[0]?.moduleAccess?.benchsales || [];

        setOriginalModuleAccess(updatedAccess);
        setSelectedPermissions(updatedAccess);

        // Extract keys for PermissionTable
        const preselectedKeys = extractCheckedKeys(updatedAccess);
        setCheckedRows(preselectedKeys);
        showToast("Updated successfully", "success", 2000);
      } else {
        showToast("Error in updating module access", "error", 2000);
      }
    } catch (error) {
      console.error("Failed to update module access:", error);
    } finally {
      setLoading(false);
    }
  };

  const sampleData = [
    {
      name: "Dashboard",
      type: "path",
      path: "bs/dashboard",
      key: "dashboard",
      children: [],
    },

    {
      name: "My Profile",
      type: "path",
      path: "profile",
      key: "profile",
      children: [],
    },
    {
      name: "Recruiters",
      type: "path",
      key: "benchsalesrecruiters",
      path: "bs/benchsales/recruiters",

      children: [
        {
          name: "Recruiters",
          type: "tab",
          key: "benchsalesrecruiters_recruiters",
          path: "bs/benchsales/recruiters#recruiters",
          children: [],
        },
      ],
    },
    {
      name: "Candidates",
      type: "path",
      key: "benchsaleshotlist",
      path: "bs/benchsales/candidates",
      children: [
        {
          name: "Candidates",
          type: "tab",
          key: "benchsaleshotlist_hotlist",
          path: "bs/benchsales/candidates#candidates",
          children: [],
        },
      ],
    },
    {
      name: "Add Candidates",
      type: "path",
      key: "benchsaleshotlist_hotlist_addcandidate",
      path: "bs/benchsales/candidates/add-new-candidate",
      // children: [
      //   {
      //     name: "Add Candidates",
      //     type: "path",
      //     key: "benchsaleshotlist_hotlist_addcandidate",
      //     path: "bs/benchsales/candidates/add-new-candidate",
      //     children: [],
      //   },
      // ],
    },
    {
      name: "Edit Candidates",
      type: "path",
      key: "benchsaleshotlist_hotlist_editcandidate",
      path: "bs/benchsales/candidates/edit-new-candidate",
      // children: [
      //   {
      //     name: "Edit Candidates",
      //     type: "path",
      //     key: "benchsaleshotlist_hotlist_editcandidate",
      //     path: "bs/benchsales/candidates/edit-new-candidate",
      //     children: [],
      //   },
      // ],
    },
    {
      name: "Jobs",
      type: "path",
      key: "benchsaleskultfetch",
      path: "bs/benchsales/Jobs",
      children: [
        {
          name: "Jobs",
          type: "tab",
          key: "benchsaleskultfetch_kultfetch",
          path: "bs/benchsales/Jobs#Jobs",
          children: [],
        },
      ],
    },
    {
      name: "Mail",
      type: "path",
      key: "mails", // must match the id in bsNavLinkData and BsRoutes
      path: "bs/mail",
      children: [],
    },
    {
      name: "Posts",
      type: "path",
      key: "benchsalesposts",
      path: "bs/benchsales/posts",
      children: [
        {
          name: "Posts",
          type: "tab",
          key: "benchsalesposts_configs",
          path: "bs/benchsales/posts#configs",
          children: [],
        },
      ],
    },
    {
      name: "Submissions",
      type: "path",
      key: "benchsalessubmission",
      path: "bs/benchsales/submissions",
      children: [
        {
          name: "Submissions",
          type: "tab",
          key: "benchsalessubmission_submission",
          path: "bs/benchsales/submissions#submissions",
          children: [],
        },
      ],
    },
    {
      name: "Interviews",
      type: "path",
      key: "benchsalesinterview",
      path: "bs/benchsales/interview",
      children: [
        {
          name: "Interviews",
          type: "tab",
          key: "benchsalesinterview_interview",
          path: "bs/benchsales/interview#interviews",
          children: [],
        },
      ],
    },
    {
      name: "Placements",
      type: "path",
      key: "benchsalesplacement",
      path: "bs/benchsales/placements",
      children: [
        {
          name: "Placements",
          type: "tab",
          key: "benchsalesplacement_placement",
          path: "bs/benchsales/placements#placements",
          children: [],
        },
      ],
    },
    {
      name: "Templates",
      type: "path",
      key: "benchsalestemplate",
      path: "bs/benchsales/templates",
      children: [
        {
          name: "Templates",
          type: "tab",
          key: "benchsalestemplate_template",
          path: "bs/benchsales/templates#templates",
          children: [],
        },
      ],
    },
    {
      name: "Marketplace",
      type: "path",
      key: "marketplace",
      path: "marketplace",
      children: [
        {
          name: "Marketplace",
          type: "tab",
          key: "marketplace_marketplace",
          path: "marketplace#marketplace",
          children: [],
        },
      ],
    },
    {
      name: "Marketplace Setup",
      type: "path",
      key: "marketplace_setup",
      path: "marketplace/setup",
      children: [],
    },
    {
      name: "Settings",
      type: "path",
      key: "settings",
      path: "ats/settings",
      children: [
        {
          name: "Company Profile",
          type: "tab",
          key: "settings_companyprofile",
          path: "ats/settings#company-profile",
          children: [
            {
              name: "General Details",
              type: "tab",
              key: "settings_companyprofile_generaldetails",
              children: [],
            },
            {
              name: "Branding",
              type: "tab",
              key: "settings_companyprofile_branding",
              children: [],
            },
            {
              name: "Locale Information",
              type: "tab",
              key: "settings_companyprofile_localinformation",
              children: [],
            },
            {
              name: "Billing & Subscription",
              type: "tab",
              key: "settings_companyprofile_blllingsubscription",
              children: [],
            },
          ],
        },
        {
          name: "Configurations",
          type: "tab",
          key: "settings_configurations",
          path: "ats/settings#configurations",
          children: [
            {
              name: "Automation",
              type: "tab",
              key: "settings_configurations_automation",
              children: [],
            },
            {
              name: "Global Settings",
              type: "tab",
              key: "settings_configurations_globalsettings",
              children: [],
            },
            {
              name: "General Settings",
              type: "tab",
              key: "settings_configurations_generalsettings",
              children: [
                {
                  name: "RA Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_rasettings",
                  children: [
                    {
                      name: "Company Settings",
                      type: "tab",
                      key: "settings_configurations_generalsettings_rasettings_companysetting",
                      children: [],
                    },
                    {
                      name: "Google Search Account Settings",
                      key: "settings_configurations_generalsettings_rasettings_googleSetting",
                      type: "tab",
                      children: [],
                    },
                  ],
                },
                {
                  name: "BDM Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_bdmsettings",
                },
                {
                  name: "Recruitement",
                  type: "tab",
                  key: "settings_configurations_generalsettings_recruitement",
                },
                {
                  name: "Bench Sale Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_benchsalesetting",
                },
              ],
            },
            {
              name: "Integration",
              type: "tab",
              key: "settings_configurations_integration",
              children: [],
            },
          ],
        },
        {
          name: "Access Control",
          type: "tab",
          key: "settings_accesscontrol",
          path: "ats/settings#access-control",
          children: [
            {
              name: "User Teams",
              type: "tab",
              key: "settings_accesscontrol_userteams",
              children: [],
            },
            {
              name: "Security",
              type: "tab",
              key: "settings_accesscontrol_security",
              children: [
                {
                  name: "Role",
                  type: "tab",
                  key: "settings_accesscontrol_security_role",
                },
                {
                  name: "Module Access",
                  type: "tab",
                  key: "settings_accesscontrol_security_moduleaccess",
                  children: [
                    {
                      name: "ATS",
                      type: "tab",
                      key: "settings_accesscontrol_security_moduleaccess_ats",
                    },
                    {
                      name: "WorkForce",
                      type: "tab",
                      key: "settings_accesscontrol_security_moduleaccess_workforce",
                    },
                  ],
                },
                {
                  name: "Report Access",
                  type: "tab",
                  key: "settings_accesscontrol_security_reportaccess",
                },
                {
                  name: "IP Whitelist",
                  type: "tab",
                  key: "settings_accesscontrol_security_iprestriction",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Add User",
      type: "path",
      key: "adduser",
      path: "settings/add-user",
      children: [],
    },
    {
      name: "Help",
      type: "path",
      key: "help",
      path: "bs/help",
      children: [],
    },
    // {
    //   name: "Company-profile",
    //   type: "path",
    //   path: "ats/settings/company-profile",
    //   children: [
    //     {
    //       name: "View",
    //       type: "tab",
    //       children: [
    //         {
    //           name: "nested-View",
    //           type: "tab",
    //           children: [
    // {
    //   name: "Level 3",
    // },
    // {
    //   name: "child",
    // },
    //           ],
    //         },
    //         {
    //           name: "nested_child",
    //         },
    //       ],
    //     },
    //     {
    //       name: "Edit",
    //       type: "tab",
    //       children: [],
    //     },
    //   ],
    // }
  ];
  const extractCheckedKeys = (items) => {
    let keys = {};
    items.forEach((item) => {
      keys[item.key] = true;
      if (item.children && item.children.length > 0) {
        Object.assign(keys, extractCheckedKeys(item.children));
      }
    });
    return keys;
  };

  return (
    <>
      <div className="grid grid-cols-4 my-4 mx-2">
        <div className="col-span-1">
          <FormFieldSet
            type="benchsalesRoles"
            title="Role"
            placeholder="Select"
            value={checkMultiSelected}
            onChange={handleRoleChange}
            showSearch
          />
        </div>
      </div>
      {loading ? (
        <div className="flex items-center justify-center min-h-[60vh]">
          <LogoLoader />
        </div>
      ) : (
        <div>
          <PermissionTable
            data={sampleData}
            onSelectionChange={setSelectedPermissions}
            preselectedModules={originalModuleAccess}
          />
          <div className="flex justify-end mt-5 mx-5">
            <Button title="Save" onClick={handleSave} />
          </div>
        </div>
      )}
    </>
  );
};

export default Benchsales;
